<template>
  <div class="bg-white border border-solid border-grey-light rounded-lg sm:p-7 p-5">
    <div v-if="updatesLoading" class="card-loader"></div>
    <template v-else>
      <p :class="`text-sm opacity-75 ${$i18n.locale === 'en' ? 'tracking-widest' : ''}`">{{ $t('LATEST ANNOUNCEMENTS') }}</p>
      <div class="md:mt-6 mt-5 md:text-lg flex flex-col gap-3 sm:mr-[-21px] mr-[-14px] sm:pr-5 pr-3 xl:max-h-[130px] max-h-[200px] overflow-y-auto">
        <div v-for="update in updates" :key="update.id" class="flex md:gap-6 gap-3 items-start">
          <p class="opacity-75 whitespace-nowrap">{{ update.date }}</p>
          <p class="text-black">
            {{ $i18n.locale === 'en' ? update.en_text : update.ar_text }}
            <a class="underline" style="word-break: break-word;" :href="update.link_url" target="_blank">{{ $i18n.locale === 'en' ? update.en_link_text : update.ar_link_text }}</a>
          </p>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import { sendRequest } from '../../../http/axios/requestHelper'

export default {
  data () {
    return {
      updates: [],
      updatesLoading: false
    }
  },
  methods: {
    loadUpdates () {
      this.updatesLoading = true
      sendRequest(false, false, this, 'api/v1/announcements/?limit=5', 'get', null, true, 
        (response) => {
          this.updates = response.data.results
          this.updatesLoading = false
        })
    }
  },
  created () {
    this.loadUpdates()
  }
}
</script>